import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { RootState } from 'store/configureStore';
import { tasksOp } from 'store/ducks/Tasks';
import { complianceEstOp } from 'store/ducks/ComplienceEst';
import { IPopoverState, ITextAreaBoxProps } from 'store/ducks/Tasks/types';
import CustomTextarea from '../CustomTextarea';
import RichTextEditor from '../RichTextEditor';
import useDeleteWithDependencyCheck from 'utils/hooks/useDeleteWithDependencyCheck';
import ApiService from 'utils/ApiCalls';
import * as Styled from './TextAreaBoxTasks.styled';

const { useToken } = theme;

export const TextAreaBoxTasks: React.FC<ITextAreaBoxProps> = ({
  task,
  solId,
  taskId
}) => {
  const { token } = useToken();
  const dispatch = useDispatch();

  const { commentsData, scheme } = useSelector((state: RootState) => ({
    commentsData: state.complianceEst.commentsData,
    scheme: state.global.scheme
  }));

  const [popoverState, setPopoverState] = useState<IPopoverState>({});

  const { handleDelete: handleTaskDelete } = useDeleteWithDependencyCheck({
    tableName: 'tasks',
    softDeleteFn: (id) => ApiService.softDeleteRecord('tasks', id),
    onSuccess: (id) => {
      dispatch(tasksOp.deleteTask(id, solId));
    },
    entityLabel: 'task'
  });

  const handleDeleteClick = () => {
    const isTemporary = String(taskId).startsWith('new-');
    if (isTemporary) {
      dispatch(tasksOp.deleteTask(taskId, solId));
    } else {
      handleTaskDelete(Number(taskId));
    }
  };

  const hide = (id: number | string) => {
    if (!id) return;

    setPopoverState((prevState) => ({
      ...prevState,
      [id]: false
    }));
  };

  // const drawComments = () => {
  //   const filteredComments = commentsData?.length
  //     ? commentsData.filter(
  //         (commentsDataItem: CommentItem) =>
  //           commentsDataItem.res_table_pk_ref === taskId
  //       )
  //     : [];

  //   return (
  //     <>
  //       <CommentSection
  //         reqId={solId}
  //         data={filteredComments}
  //         tableRef={CommentTable.TASKS}
  //       />
  //       <a onClick={() => hide(taskId)}>Close</a>
  //     </>
  //   );
  // };

  const handleOpenChange = (id: number | string) => {
    if (!id) return;

    setPopoverState((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };

  return (
    <Styled.TextAreaElementsContainer>
      <Styled.TextAreaElementsContainer>
        <RichTextEditor
          value={task.tsk_desc}
          onChange={(value) => {
            dispatch(tasksOp.editTaskValue(taskId, task, 'tsk_desc', value));
            dispatch(complianceEstOp.setSaveDisabled(false));
          }}
          onSave={(value) => {
            dispatch(tasksOp.editTaskValue(taskId, task, 'tsk_desc', value));
            dispatch(complianceEstOp.setSaveDisabled(false));
          }}
          placeholder='Type Task'
          scheme={scheme}
        />
        <Styled.StyledButtonSection token={token}>
          {/* Comment section hidden
          <Popover
            placement='leftBottom'
            trigger='click'
            content={drawComments}
            title='Comments'
            open={!!(taskId && popoverState[taskId])}
            onOpenChange={() => handleOpenChange(taskId)}
          >
            <CustomIconButton
              type='primary'
              shape='circle'
              icon={<CommentOutlined />}
              size='small'
              cursor='pointer'
            />
          </Popover>
          */}

          <Styled.StyledCustomIconButton
            token={token}
            type='primary'
            shape='circle'
            icon={<DeleteOutlined />}
            cursor='pointer'
            size='small'
            onClick={handleDeleteClick}
          />
        </Styled.StyledButtonSection>
      </Styled.TextAreaElementsContainer>
    </Styled.TextAreaElementsContainer>
  );
};
